/* eslint-disable import/max-dependencies */
import type { ReactNode, FC } from "react";
import React from "react";
import { Helmet } from "react-helmet";
import { Box, Typography } from "@mui/material";
import { withStyles } from "@mui/styles";
import { SetupCard, withState } from "@fas/cpa-cabinet-ui";
import Chart from "../Chart";
import { useChart } from "../../hooks";
import DividerBlock from "./DividerBlock";
import { setupCardStyles } from "../../styles";
import { useLocalStorage } from "../../hooks/useStorage";
import HelpUkraineBanner from "./HelpUkraineBanner";
import BestOffers from "../BestOffers";
import InfoBannerComponent from "../InfoBanner";

const ChartComponent = withState(Chart, useChart);
const StyledSetupCard = withStyles(setupCardStyles)(SetupCard);
const Banner = withState(HelpUkraineBanner, (): any => {
  const [open, setOpen] = useLocalStorage<boolean>("ukrBannerModal", true);
  return {
    open,
    onClose: () => setOpen(false),
  };
});
const InfoBanner = InfoBannerComponent;

function Dashboard() {
  return (
    <StyledSetupCard title="">
      <Helmet>
        <title>
          Dashboard
        </title>
      </Helmet>
      <Box
        width={1}
        height={1}
        flexWrap="nowrap"
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            lg: "row",
          },
          alignItems: "stretch",
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          width={1}
          flexWrap="nowrap"
          sx={{
            overflow: {
              xs: "visible",
              lg: "hidden",
            },
          }}
        >
          <Box
            sx={{
              display: {
                xs: "flex",
                md: "none",
              },
              gap: 1,
              mb: 2,
              "&:empty": {
                display: "none",
              },
            }}
          >
            <Banner />
            <InfoBanner />
          </Box>

          <Box
            width={1}
            flexDirection="column"
            sx={{
              display: "flex",
              flex: "1",
              overflow: {
                xs: "visible",
                lg: "hidden",
              },
            }}
          >
            <Box>
              <Typography variant="gradientH4">
                Dashboard
              </Typography>
            </Box>
            <ChartComponent />
          </Box>
        </Box>
        <DividerBlock />
        <Box
          data-testid="best-opportunities-component"
          sx={{
            flexDirection: "column",
            display: {
              xs: "block",
              lg: "flex",
            },
            height: {
              xs: "fit-content",
              lg: "100%",
            },
            marginTop: {
              xs: "40px",
              lg: "0",
            },
            "& .MuiTableContainer-root": {
              overflowX: {
                sx: "auto",
                md: "hidden",
              },
            },
          }}
        >
          <BestOffers />
        </Box>
      </Box>
    </StyledSetupCard>
  );
}

export default Dashboard;
